// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_fNaYt {
  display : flex;
  flex-direction:row;
  justify-content:space-between;
  border-bottom:5px solid var( --background );
  padding-right:26px;
  .rndBtn_gn5IF {
    border-radius:50%;
    width : 40px;
    height : 40px;
  }

  .rndBtn_gn5IF:focus, .rndBtn_gn5IF:active, .rndBtn_gn5IF:focus:active { 
    box-shadow:none;
    outline:none;
  }
}

.list_Vnp_v {
  height : 100%;
}


.noItems_ENcIl {
  text-align: left;
  padding: 20px 20px;
}`, "",{"version":3,"sources":["webpack://./src/screens/scenario/scenariosScreen.css"],"names":[],"mappings":"AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,2CAA2C;EAC3C,kBAAkB;EAClB;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@import \"../../style/theme.css\";\n\n.header {\n  display : flex;\n  flex-direction:row;\n  justify-content:space-between;\n  border-bottom:5px solid var( --background );\n  padding-right:26px;\n  .rndBtn {\n    border-radius:50%;\n    width : 40px;\n    height : 40px;\n  }\n\n  .rndBtn:focus, .rndBtn:active, .rndBtn:focus:active { \n    box-shadow:none;\n    outline:none;\n  }\n}\n\n.list {\n  height : 100%;\n}\n\n\n.noItems {\n  text-align: left;\n  padding: 20px 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_fNaYt`,
	"rndBtn": `rndBtn_gn5IF`,
	"list": `list_Vnp_v`,
	"noItems": `noItems_ENcIl`
};
export default ___CSS_LOADER_EXPORT___;
